<ng-container *ngIf="zIndex$ | async as zIndex">
  <div class="loading-overlay" [hidden]="!loading" [style.zIndex]="zIndex">
    <div class="container">
      <portal-spinner></portal-spinner>
    </div>
  </div>
</ng-container>
